import { start } from "repl";
import DATE from "../DATE";
import LOG, { log } from "../LOG";
 
class TimerInstance
{
    public duration         : number = 0;
    public isPlaying        : boolean = false;
    public percent          = 100;
    public update           : any;
    public id               : any;
    public start            : any;
    public restart          : any;
    public stop             : any;
    public increase         : any;
    public pause            : any;
    public resume           : any;
    public onSecond         : any;
    public setAuto          : any;
    public setDuration      : any;
    public remaining        : number = 0;
    public elapsed          : number = 0;

 
    constructor( vars?:any )
    {
        var self            = this;

        vars                = vars || {};
 
        var id              = vars.id || "Timer";
        var interval        = vars.interval || 1000;
        var duration        = vars.duration || 0;
        var elapsed         = 0;
        var startTime       = vars.startTime || 0;
        var isPaused        = false;
        
        self.remaining      = 0;
        self.elapsed        = 0;
 
        var onTimeUp        = vars.onTimeUp;
        var onUpdate        = vars.onUpdate;
 
        var intervalID : any;
        var Signal          = vars.Signal;

        let logName :any    = false;// "EnergyTimer"; //

        if( id == logName ) log("NEW TIMER", id, vars );
  
        self.start = function( vars?:any ) 
        {
            vars                                                = vars || {};
            if( vars.seconds ) duration                         = self.duration = vars.seconds * 1000;
            if( vars.duration ) duration                        = self.duration = vars.duration;
            onUpdate                                            = vars.onUpdate;
            if( vars.onTimeUp ) onTimeUp                        = vars.onTimeUp;

           if( id == logName ) log("TIMER START", logName, duration, vars );
    
            self.restart( vars.startTime );
        };

        self.restart = function( _startTime?:any )
        {
            self.stop(); 

            isPaused                = false;

            startTime               = _startTime  || DATE.now();
 
            elapsed                 = DATE.now() - startTime;
     
            self.isPlaying          = true;

           if( id == logName ) log("TIMER restart", logName, _startTime, startTime, "elapsed", elapsed );
 
            self.percent            = elapsed * 100 / duration;
            self.remaining          = duration - elapsed;

            intervalID              = setInterval( update, interval );
        };
 
        self.increase = function( seconds:number )
        {
            duration += seconds * 1000;
        }
 
        self.pause = function()
        {
            if( !self.isPlaying || isPaused ) return;
            isPaused = true;
        };
 
        self.resume = function() 
        {
            isPaused = false;

            if( !self.isPlaying ) return;
            self.start({ duration:duration-elapsed, startTime:DATE.now() });
        };
     
        self.stop = function()
        {
            if( id == logName ) log("TIMER stop", logName );
            startTime = 0;
            self.isPlaying = false;
            clearInterval( intervalID );
        };
 
        self.setDuration = function( value:number )
        {
            duration = self.duration = value;
        };
    
        function onReach()
        {
            if( id == logName ) log("TIMER onReach", logName );

            self.stop();

            if( onTimeUp ) onTimeUp( self );

            if( Signal ) Signal.set( id +":onTimeUp" );
        };
 
        function update()
        {
 
            if( !self.isPlaying || isPaused ) return;
 
            self.elapsed        = elapsed = DATE.now() - startTime;

           if( id == logName )  log(logName,"update, duration", duration );
 
            if( duration )
            {
                self.percent    = elapsed * 100 / duration;
                self.remaining  = duration - elapsed;

               if( id == logName )  log(logName,"elapsed", elapsed, "remaining", self.remaining, "percent", self.percent );
                
               if( self.remaining <= 0 ) onReach(); 
            }

            if( Signal ) Signal.set( id +":onSecond", self.remaining );
 
            if( onUpdate ) onUpdate( self );
 
        }

        if( vars.autoStart ) self.start( vars );

    }
}

export default TimerInstance;